import baustein from "baustein";
import history from "web/script/utils/history";
import template from "templates/modules/feed_pagination";

var DISABLED_MODIFIER = "feed-pagination--disabled";

baustein.register("feed-pagination", {
    template: template,

    defaultOptions: {
        disabled: false,
        useClientRouting: false,
    },

    init: function() {
        this.el.classList.toggle(DISABLED_MODIFIER, this.options.disabled);
    },

    setupEvents: function(add) {
        add("click", "a", this.onClick);
    },

    onClick: function(event) {
        if (this.options.useClientRouting) {
            event.preventDefault();
            const urlPath = event.target.closest("a").href;
            history.pushState(urlPath);
        }
    },

    onOptionsChange: function() {
        this.el.classList.toggle(DISABLED_MODIFIER, this.options.disabled);
    },
});
